import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

export const MapPlaceholder = styled.div`
  width: 100%;
  height: 200px;
  border-radius: ${vimovaTheme.borderRadius.signature};
  border: 1px dashed ${vimovaTheme.colors.border};
  background: ${vimovaTheme.colors.backgroundWarm};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  box-sizing: border-box;

  @media print {
    height: 200px !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    border: 1px dashed ${vimovaTheme.colors.border} !important;
    background: ${vimovaTheme.colors.backgroundWarm} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MapPlaceholderText = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.body};
  color: ${vimovaTheme.colors.textMuted};

  @media print {
    font-size: ${vimovaTheme.fontSizes.body} !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MapImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: ${vimovaTheme.borderRadius.signature};
  margin-top: 12px;

  @media print {
    height: 200px !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const TwoColumnGrid = styled.div`
  display: flex;
  gap: 40px;
  margin-top: 20px;

  @media print {
    display: flex !important;
    gap: 40px !important;
    margin-top: 20px !important;
  }
`

/* --- Website-style section header: icon + bold title, no border --- */
export const SubSectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    margin-bottom: 10px !important;
  }
`

export const SubSectionIcon = styled.div`
  flex-shrink: 0;
  color: ${vimovaTheme.colors.warmGray};

  svg {
    display: block;
  }

  @media print {
    color: ${vimovaTheme.colors.warmGray} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SubSectionTitle = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 12px;
  color: ${vimovaTheme.colors.text};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 12px !important;
    color: ${vimovaTheme.colors.text} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SubSectionBlock = styled.div`
  flex: 1;

  @media print {
    flex: 1 !important;
  }
`

export const FullWidthBlock = styled.div`
  margin-top: 20px;

  @media print {
    margin-top: 20px !important;
  }
`

/* --- Info rows with 1px border only between rows --- */
export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px 0;

  & + & {
    border-top: 1px solid ${vimovaTheme.colors.border};
  }

  @media print {
    display: flex !important;
    justify-content: space-between !important;
    padding: 7px 0 !important;

    & + & {
      border-top: 1px solid ${vimovaTheme.colors.border} !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }
`

export const InfoLabel = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.textLight};

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const InfoValue = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  font-weight: ${vimovaTheme.fontWeights.bold};
  color: ${vimovaTheme.colors.textLight};

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* --- Score circle (development potential) --- */
export const ScoreCircleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 0;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 8px 0 !important;
  }
`

export const ScoreSvg = styled.svg`
  @media print {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScoreValue = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: ${vimovaTheme.fontSizes.large};
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: ${vimovaTheme.fontSizes.large} !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScoreMax = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${vimovaTheme.colors.textMuted};

  @media print {
    font-size: 8px !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScoreLabel = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${vimovaTheme.colors.textLight};
  margin-top: 6px;
  text-align: center;

  @media print {
    font-size: 8px !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* --- Zone d'affectation --- */
export const ZoneHighlight = styled.div`
  padding: 6px 0 6px 12px;
  position: relative;
  margin-bottom: 8px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: ${vimovaTheme.colors.primary};
    border-radius: 2px;
  }

  @media print {
    padding: 6px 0 6px 12px !important;

    &::before {
      background: ${vimovaTheme.colors.primary} !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }
`

export const ZoneName = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.small};
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.small} !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ZoneDetail = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.textLight};
  margin-top: 3px;

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ZoneStatsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 40px;

  @media print {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 0 40px !important;
  }
`

export const ZoneStatRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px 0;

  & + & {
    border-top: 1px solid ${vimovaTheme.colors.border};
  }

  @media print {
    display: flex !important;
    justify-content: space-between !important;
    padding: 7px 0 !important;

    & + & {
      border-top: 1px solid ${vimovaTheme.colors.border} !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }
`

export const ZoneStatLabel = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.textLight};

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ZoneStatValue = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  font-weight: ${vimovaTheme.fontWeights.bold};
  color: ${vimovaTheme.colors.textLight};

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* --- Restrictions --- */
export const RestrictionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;

  & + & {
    border-top: 1px solid ${vimovaTheme.colors.border};
  }

  @media print {
    display: flex !important;
    gap: 10px !important;
    padding: 8px 0 !important;

    & + & {
      border-top: 1px solid ${vimovaTheme.colors.border} !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }
`

export const RestrictionIcon = styled.div<{ $type: 'positive' | 'negative' }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-family: ${vimovaTheme.fonts.body};
  font-size: 10px;
  font-weight: ${vimovaTheme.fontWeights.bold};
  background: ${({ $type }) =>
    $type === 'positive'
      ? 'rgba(165, 204, 116, 0.15)'
      : 'rgba(239, 113, 63, 0.15)'};
  color: ${({ $type }) =>
    $type === 'positive'
      ? vimovaTheme.colors.greenDark
      : vimovaTheme.colors.orange};

  @media print {
    background: ${({ $type }) =>
      $type === 'positive'
        ? 'rgba(165, 204, 116, 0.15)'
        : 'rgba(239, 113, 63, 0.15)'} !important;
    color: ${({ $type }) =>
      $type === 'positive'
        ? vimovaTheme.colors.greenDark
        : vimovaTheme.colors.orange} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const RestrictionText = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.text};

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.text} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
